"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = void 0;
function* range(toOrFrom, to) {
    const actualFrom = to == null ? 0 : toOrFrom;
    const actualTo = to ?? toOrFrom;
    if (actualFrom <= actualTo) {
        for (let i = actualFrom; i <= actualTo; i++) {
            yield i;
        }
    }
    else {
        for (let i = actualFrom; i >= actualTo; i--) {
            yield i;
        }
    }
}
exports.range = range;
